'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlaboLanguage = undefined;

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Langguage = function () {
  function Langguage() {
    (0, _classCallCheck3.default)(this, Langguage);
  }

  (0, _createClass3.default)(Langguage, [{
    key: 'visitorAllChildren',
    value: function visitorAllChildren(parent, visitor) {
      var children = [].concat((0, _toConsumableArray3.default)(parent.children));
      while (children.length) {
        var child = children.shift();
        if (child.nodeType === 1 && child.children.length) {
          children.push.apply(children, (0, _toConsumableArray3.default)(child.children));
        }
        visitor(child);
      }
    }
  }, {
    key: 'getStyleValue',
    value: function getStyleValue(style, key) {
      var parse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : parseInt;

      return parse(style[key]) || 0;
    }
  }, {
    key: 'computedStyle',
    value: function computedStyle(node) {
      if (node.hasAttribute('no-calc')) return;
      var css = getComputedStyle(node),
          ml = this.getStyleValue(css, 'marginLeft'),
          mr = this.getStyleValue(css, 'marginRight'),
          pl = this.getStyleValue(css, 'paddingLeft'),
          pr = this.getStyleValue(css, 'paddingRight'),
          al = this.getStyleValue(css, 'left'),
          ar = this.getStyleValue(css, 'right'),
          bl = this.getStyleValue(css, 'borderLeftWidth'),
          br = this.getStyleValue(css, 'borderRightWidth');
      if (mr || ml) {
        node.style.marginLeft = mr + 'px';
        node.style.marginRight = ml + 'px';
        node.setAttribute('no-calc', '');
      }
      if (pl || pr) {
        node.style.paddingRight = pl + 'px';
        node.style.paddingLeft = pr + 'px';
        node.setAttribute('no-calc', '');
      }
      if (bl || br) {
        var blStyle = this.getStyleValue(css, 'borderLeftStyle', function (val) {
          return val;
        }),
            brStyle = this.getStyleValue(css, 'borderRightStyle', function (val) {
          return val;
        }),
            blColor = this.getStyleValue(css, 'borderLeftColor', function (val) {
          return val;
        }),
            brColor = this.getStyleValue(css, 'borderRightColor', function (val) {
          return val;
        });
        node.style.borderLeft = br + 'px ' + brStyle + ' ' + brColor;
        node.style.borderRight = bl + 'px ' + blStyle + ' ' + blColor;
        node.setAttribute('no-calc', '');
      }
      if (css.position === 'absolute' && (al || ar)) {
        node.style.left = ar + 'px';
        node.style.right = al + 'px';
        node.setAttribute('no-calc', '');
      }
    }
  }]);
  return Langguage;
}();

var AlaboLanguage = function (_Langguage) {
  (0, _inherits3.default)(AlaboLanguage, _Langguage);

  function AlaboLanguage(_ref) {
    var el = _ref.el;
    (0, _classCallCheck3.default)(this, AlaboLanguage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AlaboLanguage.__proto__ || (0, _getPrototypeOf2.default)(AlaboLanguage)).call(this));

    _this.rootSelector = el;
    return _this;
  }

  (0, _createClass3.default)(AlaboLanguage, [{
    key: 'createMutationObserver',
    value: function createMutationObserver(cb) {
      var config = { childList: true, subtree: true },
          observer = new MutationObserver(cb);
      observer.observe(this.root, config);
      return observer;
    }
  }, {
    key: 'invokeStyle',
    value: function invokeStyle() {
      var _this2 = this;

      // 初始化调用
      ;[].concat((0, _toConsumableArray3.default)(document.querySelectorAll('*'))).forEach(function (node) {
        _this2.computedStyle(node);
      });
      // 监听dom调用
      this.createMutationObserver(function (mutationsList) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(mutationsList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var mutation = _step.value;

            if (mutation.type === 'childList') {
              ;[].concat((0, _toConsumableArray3.default)(mutation.addedNodes)).forEach(function (node) {
                if (node.nodeType !== 1) return;
                _this2.computedStyle(node);
                _this2.visitorAllChildren(node, function (child) {
                  _this2.computedStyle(child);
                });
              });
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    }
  }, {
    key: 'root',
    get: function get() {
      return document.querySelector(this.rootSelector);
    }
  }]);
  return AlaboLanguage;
}(Langguage);

exports.AlaboLanguage = AlaboLanguage;